export const SET_MESSAGE = 'SET_MESSAGE';
export const CLEAR_MESSAGE = 'CLEAR_MESSAGE';

export const clearMessage = {
  type: CLEAR_MESSAGE,
}

export const setMessage = (data) => {
  return {
    type: SET_MESSAGE,
    payload: data,
  }
}